
import { ProgramCategory } from './types';

// Default program durations (in days)
export const DEFAULT_PROGRAM_DURATIONS: Record<string, number> = {
  // DIT Programs
  'Introduction to Computer': 30,
  'Windows 7,8,9,10,11': 30,
  'MS Word': 30,
  'MS Excel': 30,
  'MS Power Point': 30,
  'MS Access': 30,
  'Internet': 30,
  'Photoshop': 30,
  'Basic Hardware': 45,
  
  // Special Packages
  'MS Office Collection': 90,
  'Graphic Design': 90,
  'Programing': 120,
  'Networking': 120,
  'Coral Draw': 45,
  'Video Editing': 60,
  'Audio Editing': 60,
  'CCTV {Security Camera}': 45,
  'PBX': 30,
  
  // Web Development
  'HTML': 45,
  'CSS': 45,
  'JavaScript': 60,
  'PHP': 60,
  
  // Networking
  'MCSE': 90,
  'CCNA': 90,
  'CCNP': 120,
  'CCIE': 180,
  
  // Programming Languages
  'C': 60,
  'C++': 60,
  'Java': 90,
  'C#': 90,
  
  // Language
  'English Language': 60,
  'Arabic Language': 60,
  'Pashto Language': 60,
  
  // English File
  'File One': 30,
  'File Two': 30,
  'File Three': 30,
  'File Four': 30,
  'File Five': 30,
  'File Six': 30,
  'File Seven': 30,
  'File Eight': 30,
  'File Nine': 30,
  'File Ten': 30,
  
  // CEL Programs
  'Pre-File': 30,
  'Basic-File': 30,
  
  // DEL Programs
  'Starter': 30
  // DEL program durations for File One through File Five are already defined above
  // in the English File section, so we don't need to repeat them here
};

// Program lists by category
export const PROGRAM_LISTS: Record<ProgramCategory, string[]> = {
  'DIT Programs': [
    'Introduction to Computer',
    'Windows 7,8,9,10,11',
    'MS Word',
    'MS Excel',
    'MS Power Point',
    'MS Access',
    'Internet',
    'Photoshop',
    'Basic Hardware'
  ],
  'Special Packages': [
    'MS Office Collection',
    'Graphic Design',
    'Programing',
    'Networking',
    'Coral Draw',
    'Photoshop',
    'Video Editing',
    'Audio Editing',
    'CCTV {Security Camera}',
    'PBX',
    'Windows 7,8,9,10,11'
  ],
  'Web Development': [
    'HTML',
    'CSS',
    'JavaScript',
    'PHP'
  ],
  'Networking': [
    'MCSE',
    'CCNA',
    'CCNP',
    'CCIE'
  ],
  'Programming Languages': [
    'C',
    'C++',
    'Java',
    'C#'
  ],
  'Language': [
    'English Language',
    'Arabic Language',
    'Pashto Language'
  ],
  'English File': [
    'File One',
    'File Two',
    'File Three',
    'File Four',
    'File Five',
    'File Six',
    'File Seven',
    'File Eight',
    'File Nine',
    'File Ten'
  ],
  'CEL': [
    'Pre-File',
    'Basic-File'
  ],
  'DEL': [
    'Starter',
    'File One',
    'File Two',
    'File Three',
    'File Four',
    'File Five'
  ]
};
